<template>
  <CustomPage title="验证码">
    <div slot="content" class="content">
      <div class="box">
        <div class="t1">请输入验证码</div>
        <div class="t2">
          <span>已发送至+86 {{ phone_c }}</span>
          <span class="codeTimeout" v-if="code_flag"
            >{{ code_timeout }}s 后重新发送</span
          >
          <template v-else>
            <Loading class="resendLoading" v-if="loading" />
            <span class="resend" v-else @click="resend">重新发送</span>
          </template>
        </div>
        <div class="form">
          <PasswordInput
            :value="code"
            :length="6"
            :focused="showKeyboard"
            :mask="false"
            @focus="showKeyboard = true"
          />
        </div>
        <div class="other" v-if="type === 'code_login'">
          <span
            @click="
              $router.push({ name: 'LoginPhonePassword', query: { phone } })
            "
            >密码登录</span
          >
        </div>
      </div>
      <NumberKeyboard
        v-model="code"
        :show="showKeyboard"
        @blur="showKeyboard = false"
      />
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import { mapState } from "vuex";
import { forgetPassword, forgetPayPassword } from "@/api/login";
import { PasswordInput, NumberKeyboard, Loading, Toast } from "vant";
export default {
  components: { CustomPage, PasswordInput, NumberKeyboard, Loading },
  data() {
    return {
      loading: false,
      phone: this.$route.query.phone,
      type: this.$route.query.type,
      newPassword: this.$route.query.newPassword,
      code: "",
      showKeyboard: false,
    };
  },
  computed: {
    ...mapState({
      code_timeout: (state) => state.sms.code_timeout,
      code_flag: (state) => state.sms.code_flag,
    }),
    phone_c() {
      return this.phone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
    },
  },
  watch: {
    code(val) {
      setTimeout(() => {
        const dom = document.querySelectorAll(".van-password-input__item");
        for (let i = 0; i < 6; i++) {
          if (i <= val.length - 1) {
            dom[i].classList.add("active");
          } else {
            dom[i].classList.remove("active");
          }
        }
      }, 50);
      if (val.length === 6) {
        this.handleClick();
      }
    },
  },
  methods: {
    resend() {
      this.loading = true;
      this.$store
        .dispatch("sms/loginSendCode", this.phone)
        .then((res) => {
          this.loading = false;
          Toast.success("已发送验证码");
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleClick() {
      if (this.type === "reset_password") {
        this.reset();
      }
      if (this.type === "pay_password") {
        this.resetPay();
      }
    },
    reset() {
      this.showKeyboard = false;
      const params = {
        code: this.code,
        mobile: this.phone,
        password: this.newPassword,
      };
      this.$store.dispatch("app/showLoading");
      forgetPassword(params)
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          this.$store.dispatch("user/resetToken");
          this.$store.dispatch("sms/resetCode");
          Toast.success("重置密码成功，请重新登录");
          this.$router.push({
            name: "LoginPhonePassword",
            query: { phone: this.phone },
          });
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    resetPay() {
      this.showKeyboard = false;
      const params = {
        code: this.code,
        mobile: this.phone,
        payPassword: this.newPassword,
      };
      this.$store.dispatch("app/showLoading");
      forgetPayPassword(params)
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          this.$store.dispatch("sms/resetCode");
          Toast.success("重置支付密码成功");
          this.$router.go(-2);
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  padding: 0 40px;
}
.head {
  display: flex;
  align-items: center;
  padding: 30px 0;
  .title {
    flex: 1;
    font-size: 28px;
    line-height: 1;
    text-indent: -20px;
  }
}
.box {
  text-align: left;
  padding-top: 40px;
  .t1 {
    font-size: 36px;
    line-height: 1em;
    padding-bottom: 18px;
  }
  .t2 {
    color: #808080;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .resend {
      color: #e82035;
      font-size: 28px;
    }
    .resendLoading /deep/ .van-loading__spinner {
      width: 42px;
      height: 42px;
    }
    .codeTimeout {
      font-size: 28px;
    }
  }
  .form {
    .van-password-input {
      margin: 0;
      .van-password-input__security::after {
        border: none;
      }
    }
  }
  .other {
    text-align: center;
    font-size: 26px;
    line-height: 36px;
    padding-top: 108px;
    span {
      color: #aeaeae;
    }
  }
}
</style>
<style lang="less">
.van-password-input__item {
  margin: 0 14px;
  &::before {
    position: absolute;
    bottom: 0;
    content: "";
    left: 0;
    height: 1px;
    background: #333333;
    z-index: 9;
    width: 0;
    transition: 0.3s;
  }
  &.active::before {
    width: 100%;
  }
  &::after {
    position: absolute;
    content: "";
    border-bottom: 1px solid #aeaeae;
    border-left-width: 0;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transform: none;
  }
}
</style>
